import React from 'react'
import RequestLeaveTabComponent from './RequestLeaveTabComponent'
import PageWrapper from '../../containers/App/PageWrapper'

const RequestLeaveTabPage: React.FC = () => <div>
  <PageWrapper PageComponent={RequestLeaveTabComponent} />
</div>

export default RequestLeaveTabPage